/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Max_Event_DurationInputs */



/**
* | output |
* | --- |
* | "Maximum Event Duration (sec)" |
*
* @param {Max_Event_DurationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const max_event_duration = /** @type {((inputs?: Max_Event_DurationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Max_Event_DurationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Durée maximale d’un événement (s)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Maximale Ereignisdauer (Sek.)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Durata massima dell'evento (sec)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Максимальная продолжительность события (сек)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Duración máxima del evento (seg.)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("事件最大持续时间（秒）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("最大イベント継続時間（秒）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अधिकतम घटना अवधि (सेकंड)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Duração máxima do evento (seg)")
	return /** @type {LocalizedString} */ ("Maximum Event Duration (sec)")
});